import { useState } from "react";

import { IconEye, IconEyeOff } from "@tabler/icons";
import { FieldHookConfig, useField } from "formik";
import { useTheme } from "styled-components";

import { TextInput, TextInputProps } from "@sso/components/Form";
import { ColumnContainer } from "@sso/ui/FlexBox";
import { ProgressBar } from "@sso/ui/ProgressBar";
import { getPasswordStrengthInfo } from "@sso/utils";

export const FormikPasswordInput = (
  props: FieldHookConfig<string> & TextInputProps & { showPasswordStrength?: boolean },
) => {
  const theme = useTheme();
  const [field, meta] = useField(props);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const handleTogglePassword = () => setShowPassword(showPassword => !showPassword);

  const { strength, color, label } = getPasswordStrengthInfo(field.value, theme);
  const err = Boolean(meta.touched && meta.error);
  return (
    <ColumnContainer width="100%">
      <TextInput
        {...field}
        {...props}
        type={showPassword ? "text" : "password"}
        EndIcon={showPassword ? IconEye : IconEyeOff}
        endIconTitle={showPassword ? "Hide password" : "Show password"}
        onClickEndIcon={handleTogglePassword}
        id={props.name}
        error={err}
        errorText={err ? meta.error : null}
      />
      {props.showPasswordStrength && (
        <ProgressBar
          WrapperProps={{ padding: "0 0.5rem", margin: "-0.5rem 0 1rem 0" }}
          max={5}
          value={strength || 1}
          label={label}
          color={color}
          showValue={false}
          labelSM={2}
          barSM={10}
          labelXS={3}
          barXS={9}
          barHeight="0.75rem"
        />
      )}
    </ColumnContainer>
  );
};
